/* eslint-disable max-len */
export const ChevronLeftOutline32 = ({className}: {className?: string}) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden={true}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7071 8.29289C20.0976 8.68342 20.0976 9.31658 19.7071 9.70711L13.4142 16L19.7071 22.2929C20.0976 22.6834 20.0976 23.3166 19.7071 23.7071C19.3166 24.0976 18.6834 24.0976 18.2929 23.7071L11.6464 17.0607C11.0606 16.4749 11.0606 15.5251 11.6464 14.9393L18.2929 8.29289C18.6834 7.90237 19.3166 7.90237 19.7071 8.29289Z"
        fill="currentColor"
      />
    </svg>
  );
};
